// LoadingScreen.js
import React, { useState, useEffect } from 'react';
import './CustomLoadingComponent.css'; // Create this CSS file for styling
import thinkingImage from '../Fxer.AI (7).png'; // Adjust the path to your image

const CustomLoadingComponent = () => {
  const [text, setText] = useState('Thinking');

  useEffect(() => {
    const timer = setTimeout(() => {
      setText('Fixing');
    }, 3000); // Change text after 2 seconds

    return () => clearTimeout(timer); // Cleanup the timer
  }, []);

  return (
    <div className="loading-container">
      <img src={thinkingImage} alt="Thinking..." className="loading-image" />
      <div className="loading-text">{text}<span className="dot">.</span><span className="dot">.</span><span className="dot">.</span></div>
    </div>
  );
};

export default CustomLoadingComponent;
